import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import ArticleFormPage from "../../Sections/Knowledgebase/ArticleFormPage";

const KnowledgeBaseArticleFormComponent = () => {
  return <Dashboard sectionName={<ArticleFormPage />} />;
};

export default KnowledgeBaseArticleFormComponent;
